import { FilePdfOutlined, MailOutlined, UploadOutlined } from "@ant-design/icons";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// !SERVICES
import * as USERS_SERVICES from "api/services/auth/auth.services";

// !STYLES
import st from "../../../screens/teacher/Calendar/assets/calendar.module.css";
import "./custom.tab.module.css";
import s from "./custom.tab.module.css";

// !ANTD
import { Avatar, Button, Drawer, Input, message, Skeleton, Switch } from "antd";

// !ENUMS
import { calculateTimeDifference, formatDate, isToday, StatusCode } from "common/enums";

// !STORE
import { setBookedReservations, setSuccessCollectifSessions, setSuccessReservations, updateUser } from "store/auth/authSlice";

// !FORMATERS

import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { uploadToCloudinary } from "api/services/teacher/teacher.services";
import AppResult from "components/appResults";
import HelpPopover from "components/help";
import AppButton from "components/libs/button";
import Matiers from "components/matiers";
import { t } from "i18next";
import { useGetOrganismRoomsQuery } from "store/services/teacher/classes.services";
import ArrowBack from "../../../assets/images/app/arrow_back.svg";
import ArrowDown from "../../../assets/images/app/arrow_down.png";
import Check from "../../../assets/images/app/check.svg";
import CheckIcon from "../../../assets/images/app/checkIcon.svg";
import ClockIcon from "../../../assets/images/app/clock_icon.svg";
import Close from "../../../assets/images/app/closeDeleteIcon.svg";
import EllipseWalletOne from "../../../assets/images/app/ellipse_wallet_1.svg";
import EllipseWalletTwo from "../../../assets/images/app/ellipse_wallet_2.svg";
import EllipseWalletThree from "../../../assets/images/app/ellipse_wallet_3.svg";
import EllipseWalletFour from "../../../assets/images/app/ellipse_wallet_4.svg";
import Students from "../../../assets/images/app/iam_student.svg";
import WalletPaiement from "../../../assets/images/app/wallet_paiement_icon.svg";
import Bank from "../accordion/assets/bankwire.svg";
import PayPal from "../accordion/assets/paypal.svg";


interface CoursesRoomProps {
  course?: object | any;
  currentPage: number;
  penalty?: number;
}

const CoursesRoom: FC<CoursesRoomProps> = ({ course, currentPage, penalty }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  return (
    <>
      <div className={`${st.classeCard}`}>
        <div className={st.walletCardClassBox}>
          <div className={st.walletAvatarNameBox}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: isMobile ? "0px" : "5px", cursor: "pointer" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={course?.studId?.profile || Students}
              />
            </Avatar.Group>
            <div style={{ position: "relative", top: isMobile ? "5px" : "0px", left: isMobile ? "0px" : "15px", fontSize: isMobile ? "1em" : "13px", textTransform: "capitalize", cursor: "pointer" }}>{course?.studId?.firstname ? (course?.studId?.firstname + " " + course?.studId?.lastname) : "Cours collectif"}</div>
          </div>
          {isMobile && course?.topic?.title && course?.level?.title && <Matiers
            cours={course?.topic?.title || "null"}
            level={course?.level?.title || "null"}
          />}
          <div className={currentPage === 7 ? st.penaltiesDetailsBox : st.walletDetailsBox}>
            <div className={st.timeBox}>
              {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: "10px" }}></img>}
              <div className={st.times}>
                <span className={st.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: "5px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
                <span className={st.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
              </div>
            </div>
            {!isMobile && course?.topic?.title && course?.level?.title && <div style={{ width: currentPage === 7 ? "35%" : "32%" }}>
              <Matiers
                cours={course?.topic?.title || "null"}
                level={course?.level?.title || "null"}
              />
            </div>}
            {currentPage === 7 && <div className={st.amountBox} style={{ gap: "15px" }}>
              <div className={st.penaltyPriceBox}>{"-" + penalty + " €"}</div>
            </div>}
            {currentPage !== 7 && currentPage !== 5 && <div className={st.walletAmountBox}>
              <div className={st.walletPriceBox}>{currentPage !== 5 ? course?.price + " €" : course?.grossIncomeForSession + " €"}</div>
              {currentPage !== 5 && <div className={st.commissionBox}>{course?.commissionPercentage ? course?.commissionPercentage + " %" : "Nan"}</div>}
              <div className={currentPage === 1 ? st.incomeBox : st.bookedIncomeBox}>{course?.commissionValue ? course?.price - course?.commissionValue + " €" : "Nan"}</div>
            </div>}
            {currentPage === 5 && <div className={st.walletAmountBoxCollectif}>
              <div className={st.walletPriceBox}>{course?.grossIncomeForSession + " €"}</div>
              <div className={st.commissionBox}>{course?.creditsForSession ? course?.creditsForSession : "Nan"}</div>
            </div>}
          </div>
        </div>
      </div>
    </>
  );
};

interface CustomTabInterface {
  setCanWithdrawal: React.Dispatch<React.SetStateAction<boolean>>;
  canWithdrawal: boolean;
}

export const CustomTab: React.FC<CustomTabInterface> = ({
  setCanWithdrawal: setCanWithdrawal,
  canWithdrawal,
}) => {
  // !HOOKS
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [rib, setRIB] = useState<string>(auth.user?.rib || "");

  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(auth?.user?._id);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  const { successReservations } = useSelector((state) => state.auth);
  const { bookedReservations } = useSelector((state) => state.auth);
  const { successCollectifSessions } = useSelector((state) => state.auth);
  const [loadingRetrait, setLoadingRetrait] = useState(false);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [currentPage, setCurrentPage] = useState<any>(1);
  const [checkingPaymentInfo, setCheckingPaymentInfo] = useState<boolean>(false);
  const [addPaymentInfo, setAddPaymentInfo] = useState<boolean>(false);
  const [havingPenalty, setHavingPenalty] = useState<boolean>(false);
  const [successCourses, setSuccessCourses] = useState<any>([]);
  const [bookedCourses, setBookedCourses] = useState<any>([]);
  const [withdraws, setWithdraws] = useState<any>([]);
  const [penalties, setPenalties] = useState<any>([]);
  const [totalIncome, setTotalIncome] = useState<number>(0);
  const [platformCommission, setPlatformCommission] = useState<number>(0);
  const [penalty, setPenalty] = useState<number>(0);
  const [income, setIncome] = useState<number>(0);
  const [selectedPaymentType, setSelectedPaymentType] = useState<any>();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [bankDocUrl, setBankDocUrl] = useState<any>("");
  const [paypalEmail, setPaypalEmail] = useState<string>("");
  const [displayPreview, setDisplayPreview] = useState<boolean>(false);
  const [penaltiesDrawerOpen, setPenaltiesDrawerOpen] = useState<boolean>(false);
  const [withdrawDrawerOpen, setWithdrawDrawerOpen] = useState<boolean>(false);
  const [bankPayment, setBankPayment] = useState(true);

  const [havingPenaltyCollectif, setHavingPenaltyCollectif] = useState<boolean>(false);
  const [penaltyCollectif, setPenaltyCollectif] = useState<number>(0);
  const [walletSummary, setWalletSummary] = useState<any>();
  const [successCollectifCourses, setSuccessCollectifCourses] = useState<any>([]);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedClassroom, setSelectedClassroom] = useState<any>();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [collectifAmount, setcollectifAmount] = useState<number>(0);
  const [isCollectifWithdrawal, setIsCollectifWithdrawal] = useState<boolean>(false);

  const handleSelect = (classroom: any) => {
    setSelectedClassroom(classroom);
    setIsOpen(false);
    getCollectifWalletSummary(classroom?._id);
    getSuccessCollectifCourses(classroom?._id);
  };

  const handleCollectifWithdraw = (amount: any) => {
    setIsCollectifWithdrawal(true);
    setcollectifAmount(amount);
    setWithdrawDrawerOpen(true);
  };

  useEffect(() => {
    if (!loadingOrganismRooms && organismRooms?.data?.length) {
      const data = organismRooms?.data;
      setSelectedClassroom(data[0]);
      getCollectifWalletSummary(data[0]?._id);
      getSuccessCollectifCourses(data[0]?._id);
    }
  }, [loadingOrganismRooms, organismRooms]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const validateMessages = {
    required: t("auth.error.required"),
    types: {
      email: t("auth.error.emailInvalid"),
    },
  };

  const type = [
    {
      "name": "Virement bancaire",
      "icon": Bank,
      "description": "Insère ici ton attestation de RIB bancaire et veille à ce qu'elle soit bien lisible.",
      "uploadText": "Attestation de RIB en format PDF"
    },
    {
      "name": "Compte Paypal",
      "icon": PayPal,
      "description": "Insère ici ton adresse email pour recevoir le paiement par paypal.",
      "uploadText": "Entre ton adresse email"
    }
  ];

  const updateBankInfos = async () => {
    try {
      setIsLoading(true);
      if (auth.user?._id) {
        const teacherId = auth.user?._id;
        await USERS_SERVICES.updateTeacher(teacherId, {
          rib: bankDocUrl,
        });
        setIsLoading(false);
        message.success({
          content: "Mise à jour effectuée avec succès !",
        });
        dispatch(
          updateUser({
            ...auth?.user,
            rib: bankDocUrl,
          })
        );
      }
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const updatePaypalInfos = async () => {
    if (paypalEmail === "") {
      message.warning({
        content: "Merci de saisir une adresse email !",
      });
      return;
    }
    try {
      setIsLoading(true);
      if (auth.user?._id) {
        const teacherId = auth.user?._id;
        await USERS_SERVICES.updateTeacher(teacherId, {
          paypal: paypalEmail,
        });
        setIsLoading(false);
        message.success({
          content: "Mise à jour effectuée avec succès !",
        });
        dispatch(
          updateUser({
            ...auth?.user,
            paypal: paypalEmail,
          })
        );
      }
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const sendWithdrawRequest = async (id: string) => {
    if (bankPayment && !auth?.user?.rib) {
      message.warning({
        content: "Merci de d'ajouter ton rib pour le virement bancaire !",
      });
      return;
    }
    if (!bankPayment && !auth?.user?.paypal) {
      message.warning({
        content: "Merci de d'ajouter ton adresse mail pour le paiement PayPal !",
      });
      return;
    }
    try {
      setLoadingRetrait(true);
      if (id) {
        const response = await USERS_SERVICES.createRetrait({
          teacherId: id,
          paymentType: bankPayment ? "bank" : "paypal",
        });
        if (response?.statusCode === StatusCode.CREATED) {
          message.success({
            content: "Demande de retrait envoyée avec succès",
          });
          setCanWithdrawal(false);
        }
        else {
          message.warning({
            content: response?.message,
          });
        }
      }
    } catch (error: any) {
      message.warning({
        content: "Merci de completer les informations du paiment",
      });
    }
    finally {
      setLoadingRetrait(false);
    }
  };

  const sendCollectifWithdrawRequest = async (teacherId: string, classeId: string) => {
    if (bankPayment && !auth?.user?.rib) {
      message.warning({
        content: "Merci de d'ajouter ton rib pour le virement bancaire !",
      });
      return;
    }
    if (!bankPayment && !auth?.user?.paypal) {
      message.warning({
        content: "Merci de d'ajouter ton adresse mail pour le paiement PayPal !",
      });
      return;
    }
    try {
      setLoadingRetrait(true);
      if (teacherId && classeId) {
        const response = await USERS_SERVICES.createCollectifRetrait({
          teacherId: teacherId,
          classeId: classeId,
        });
        if (response?.statusCode === StatusCode.CREATED) {
          message.success({
            content: "Demande de retrait envoyée avec succès",
          });
          getCollectifWalletSummary(selectedClassroom?._id);
        }
        else {
          message.warning({
            content: response?.message,
          });
        }
      }
    } catch (error: any) {
      message.warning({
        content: "Merci de completer les informations du paiment",
      });
    }
    finally {
      setLoadingRetrait(false);
    }
  };

  const getPaymentDetails = async (id: string) => {
    try {
      const response = await USERS_SERVICES.getPaymentDetails(id);
      if (response?.statusCode === StatusCode.OK) {
        setTotalIncome(response?.data?.total);
        setPlatformCommission(response?.data?.commission?.percentage);
        setPenalty(response?.data?.penalty);
        setIncome(response?.data?.income);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const getWithdraws = async (id: string) => {
    try {
      const response = await USERS_SERVICES.getWithdraws(id);
      if (response?.statusCode === StatusCode.OK) {
        setWithdraws(response?.data?.retraits);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const getPenalties = async (id: string) => {
    try {
      setIsLoading(true);
      const response = await USERS_SERVICES.getPenalties(id);
      if (response?.statusCode === StatusCode.OK) {
        setPenalties(response?.data);
      }
    } catch (error: any) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const getCollectifWalletSummary = async (classeId: string) => {
    try {
      setIsLoading(true);
      const response = await USERS_SERVICES.getCollectifWalletSummary(auth?.user?._id, classeId);
      if (response?.statusCode === StatusCode.OK) {
        setWalletSummary(response?.data);
      }
    } catch (error: any) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const openPenaltiesDrawer = () => {
    setPenaltiesDrawerOpen(true);
    getPenalties(auth?.user?._id);
  }

  function confirmWithdrawRequest() {
    if (!canWithdrawal) {
      message.warning({
        content: "Désolé, tu ne peux pas demander un retrait en ce moment !",
      });
      return;
    }
    sendWithdrawRequest(auth?.user?._id || "");
  }

  function confirmCollectifWithdrawRequest() {
    if (!walletSummary?.canWithdrawal) {
      message.warning({
        content: "Désolé, tu ne peux pas demander un retrait en ce moment !",
      });
      return;
    }
    sendCollectifWithdrawRequest(auth?.user?._id, selectedClassroom?._id);
  }

  const getSuccessReservations = useCallback(async () => {
    try {
      if (auth.user?._id && auth.user?.roles.includes("teacher")) {

        const teacherId = auth.user?._id;
        const response = await USERS_SERVICES.getWalletSuccessReservationsHistory(teacherId);
        if (response?.statusCode === StatusCode.OK) {

          const groupedByDate = response?.data.reduce((acc: any, course: any) => {
            const date = new Date(course.startDate).toISOString().split("T")[0];
            if (!acc[date]) {
              acc[date] = [];
            }
            acc[date].push(course);
            return acc;
          }, {});

          setSuccessCourses(groupedByDate);
          dispatch(setSuccessReservations(response?.data));
        }
      }
    } catch (error: any) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }, [auth.user?._id, auth.user?.roles, dispatch]);

  const getBookedReservations = useCallback(async () => {
    try {
      if (auth.user?._id && auth.user?.roles.includes("teacher")) {

        const teacherId = auth.user?._id;
        const response = await USERS_SERVICES.getWalletBookedReservationsHistory(teacherId);
        if (response?.statusCode === StatusCode.OK) {

          const groupedByDate = response?.data.reduce((acc: any, course: any) => {
            const date = new Date(course.startDate).toISOString().split("T")[0];
            if (!acc[date]) {
              acc[date] = [];
            }
            acc[date].push(course);
            return acc;
          }, {});

          setBookedCourses(groupedByDate);
          dispatch(setBookedReservations(response?.data));
        }
      }
    } catch (error: any) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }, [auth.user?._id, auth.user?.roles, dispatch]);

  const getSuccessCollectifCourses = async (classeId: string) => {
    try {
      const response = await USERS_SERVICES.getSuccessCollectifCourses(auth.user?._id, classeId);
      if (response?.statusCode === StatusCode.OK) {

        const groupedByDate = response?.data?.data.reduce((acc: any, course: any) => {
          const date = new Date(course.startDate).toISOString().split("T")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(course);
          return acc;
        }, {});

        console.log(groupedByDate);

        setSuccessCollectifCourses(groupedByDate);
        dispatch(setSuccessCollectifSessions(response?.data?.data));
      }
    } catch (error: any) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  // Handle Name Filter
  const handleStudentName = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== undefined) {
      const searchValue = event.target.value.toLowerCase();
      if (searchValue.length >= 3) {
        const filtered = bookedReservations.filter((data: any) =>
          data.studId?.firstname?.toLowerCase().includes(searchValue) ||
          data.studId?.lastname?.toLowerCase().includes(searchValue)
        );
        if (filtered.length !== 0) {
          dispatch(setBookedReservations(filtered));
        }
      }
      else {
        getBookedReservations();
      }
    }
    else {
      getBookedReservations();
    }
  };

  // Handle Status Filter
  const handleStatusChange = (value: string) => {
    if (value !== undefined) {
      const filtered = bookedReservations.filter((data: any) => data.status === value);
      if (filtered.length !== 0) {
        dispatch(setBookedReservations(filtered));
      }
      else {
        message.warning({
          content: `${value === "BOOKED" ? "Aucun résulta pour en cours" : "Aucun paiement validé"}`,
        });
      }
    }
    else {
      getBookedReservations();
    }
  };

  // Handle Organism Filter
  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      /* getOrganismReservationsHistory(); */
      const filtered = bookedReservations.filter((data: any) => data.byCredits === "oui" || data?.byCredits === "true" || data?.byCredits === true);
      if (filtered.length !== 0) {
        dispatch(setBookedReservations(filtered));
      }
      else {
        message.warning({
          content: `Aucun résulta pour organisme`,
        });
      }
    }
    else {
      getBookedReservations();
    }
  };

  ///Upload Certificate
  const uploadBankDocPicture = async (file: any) => {
    try {
      const response = await uploadToCloudinary(file, "RIB");
      if (response?.statusCode === StatusCode.CREATED) {
        const secureUrl = response?.data.replace(/^http:\/\//i, "https://");
        console.log(secureUrl);
        setBankDocUrl(secureUrl);
      }
      else {
        message.warning({
          content: "une erreur est survenue",
        });
      }
    } catch (error: any) {
      let content = "";
      for (let i = 0; i < error?.response?.data?.message?.length; i++) {
        content = error?.response?.data?.message[i] + ", " + content;
      }
      message.error({
        content: content,
      });
    }
    finally {
      setIsLoading(false);
    }
  }

  //Drag & Drop Functions
  function handleFile(files: any) {
    const file = files[0];
    const maxSize = 5 * 1024 * 1024;
    const reader = new FileReader();
    const allowedTypes = [
      "application/pdf",
    ];

    if (file && file.size <= maxSize && allowedTypes.includes(file.type)) {
      reader.onload = () => {
        uploadBankDocPicture(file);
      };
      reader.readAsDataURL(file);
      setIsLoading(true);
    }
    else {
      setIsLoading(false);
    }
  }

  // triggers the input when the button is clicked
  const handleClick = () => {
    if (fileInputRef.current != null) {
      fileInputRef.current.click();
    }
  };

  // triggers when file is selected with click
  const handleChange = (e: any) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files);
    }
  };

  useEffect(() => {
    getBookedReservations();
  }, [getBookedReservations]);

  useEffect(() => {
    getSuccessReservations();
  }, [getSuccessReservations]);

  useEffect(() => {
    if (auth?.user?._id) {
      getPaymentDetails(auth?.user?._id);
      getWithdraws(auth?.user?._id);
    }
  }, [auth]);

  useEffect(() => {
    if (penalty && penalty > 0) {
      setHavingPenalty(true);
    }
  }, [penalty]);

  useEffect(() => {
    if (bankDocUrl !== "") {
      setDisplayPreview(true);
    }
  }, [bankDocUrl]);

  return (
    <>
      <div className={s.cardContainer}>
        {!isMobile && <img src={EllipseWalletOne} height={50} style={{ position: "absolute", top: "12%", left: "50px", zIndex: "0" }}></img>}
        {!isMobile && <img src={EllipseWalletTwo} height={70} style={{ position: "absolute", top: "25%", right: "60px", zIndex: "0" }}></img>}
        {!isMobile && <img src={EllipseWalletThree} height={70} style={{ position: "absolute", bottom: "5%", left: "2%", zIndex: "0" }}></img>}
        {!isMobile && <img src={EllipseWalletFour} height={50} style={{ position: "absolute", bottom: "5%", right: "5%", zIndex: "0" }}></img>}
        <div style={{ display: "flex", flexDirection: "column", height: "auto", width: "100% !important", alignItems: "flex-start", justifyContent: "space-between" }}>

          <div style={{ display: "flex", flexDirection: "row", height: "100px", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
            <div className={isMobile ? s.soldeBoxColumn : s.pageSoldeBox}>
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", height: "auto", width: "100%", alignItems: "center", justifyContent: "space-between", marginBottom: isMobile ? "0px" : "0px" }}>
                <div className={s.pageButtonBox}>
                  <div onClick={() => { setCurrentPage(1); setCheckingPaymentInfo(false); setAddPaymentInfo(false); }} className={s.pageButton} style={{ background: currentPage === 1 ? "#80b1b2" : "#FFF", color: currentPage === 1 ? "#FFF" : "#868686", border: currentPage === 1 ? "1px solid #7FB1B2" : "1px solid #E5E4E4" }}>Mon portfeuille</div>
                  <div onClick={() => { setCurrentPage(2); setCheckingPaymentInfo(false); setAddPaymentInfo(false); }} className={s.pageButton} style={{ background: currentPage === 2 ? "#80b1b2" : "#FFF", color: currentPage === 2 ? "#FFF" : "#868686", border: currentPage === 2 ? "1px solid #7FB1B2" : "1px solid #E5E4E4" }}>Solde en cours</div>
                  <div onClick={() => { setCurrentPage(5); setCheckingPaymentInfo(false); setAddPaymentInfo(false); }} className={s.pageButton} style={{ background: currentPage === 5 ? "#80b1b2" : "#FFF", color: currentPage === 5 ? "#FFF" : "#868686", border: currentPage === 5 ? "1px solid #7FB1B2" : "1px solid #E5E4E4" }}>Solde organisme</div>
                  <div onClick={() => { setCurrentPage(3); setCheckingPaymentInfo(false); setAddPaymentInfo(false); }} className={s.pageButton} style={{ background: currentPage === 3 ? "#80b1b2" : "#FFF", color: currentPage === 3 ? "#FFF" : "#868686", border: currentPage === 3 ? "1px solid #7FB1B2" : "1px solid #E5E4E4" }}>Mes retraits</div>
                </div>

                <div onClick={() => { setCurrentPage(4); setCheckingPaymentInfo(true); setAddPaymentInfo(false); }} className={currentPage === 4 ? s.paymentInfoButtonActive : s.paymentInfoButton}>
                  <img src={WalletPaiement} height={18} style={{ marginRight: "10px" }}></img> Informations du paiement
                </div>
              </div>
            </div>
          </div>
          <div className={s.detailsBox}>
            {/* <div className={s.detailsBoxTitle}>Gérer ton portefeuille <span style={{ marginLeft: "10px" }}><HelpPopover id={"portfeuille_gerer_ton_portefeuille"}></HelpPopover></span></div> */}
            {currentPage === 1 && <div className={s.pageOneBox}>
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", height: "auto", width: "100%", alignItems: "center", justifyContent: "space-between", marginBottom: isMobile ? "10px" : "0px" }}>
                <div className={s.pageButtonBox}>
                  {havingPenalty && penalty > 0 && <div onClick={openPenaltiesDrawer} className={s.dashedBox} style={{ background: "#F7E4E4", color: "#F56666" }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                      Oups ! Tu as une pénalité d’annulation de {" "}
                      <span style={{ color: "#F56666", fontWeight: "bold" }}> -{penalty} €</span>
                    </div>
                    <span style={{ color: "#F56666", fontWeight: "bold", marginLeft: "5px", textDecoration: "underline", cursor: "pointer" }}>En savoir plus</span>
                  </div>}
                </div>
                <div className={s.withdrawButtonBox}>
                  <div className={s.dashedBox} style={{ background: income < 0 ? "#F566665F" : "#E5FFF2", color: income < 0 ? "#F56666" : "#4BB980", fontWeight: "bold" }}>
                    Revenu net : {Number(income.toFixed(2))} €
                  </div>
                  {income > 0 ? canWithdrawal ? (
                    <Button className={s.newButton} onClick={() => setWithdrawDrawerOpen(true)}>Demander un retrait</Button>
                  ) : (
                    <Button className={isMobile ? s.demandeRetraitButtonMobile : s.demandeRetraitButton}>
                      Paiement en cours de traitement...
                    </Button>
                  ) : <></>}
                </div>
              </div>

              {!isMobile && successReservations?.length > 0 && <div className={s.courseInfoTitle}>
                <span>Revenu<br />brute</span>
                <span>Commission<br />Plateforme</span>
                <span>Revenu<br />net</span>
              </div>}

              <div className={s.coursesBox}>
                {isLoading ? <>
                  <Skeleton></Skeleton>
                  <Skeleton></Skeleton>
                  <Skeleton></Skeleton>
                </> : successReservations?.length > 0 ? (
                  successCourses && Object.keys(successCourses)?.map((date) => {
                    return (
                      <>
                        <div key={date} style={{ marginTop: "10px" }}>
                          <div className={st.dateBox}>
                            {new Intl.DateTimeFormat("fr-FR", {
                              weekday: "long",
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }).format(new Date(date))}
                            {isToday(date) && <div className={st.todayBox}>Aujourd’hui</div>}
                            <div className={st.horizontalLine}></div>
                          </div>
                          {!isMobile && successCourses[date].map((course: any) => (
                            <div key={course.id}>
                              <CoursesRoom course={course} currentPage={currentPage} />
                            </div>
                          ))}

                          {isMobile && <div className={st.cardDisplay}>
                            {successCourses[date].map((course: any) => (
                              <div key={course.id}>
                                <CoursesRoom course={course} currentPage={currentPage} />
                              </div>
                            ))}
                          </div>}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <div className={s.emptyClass}>
                    <AppResult status={"info"} title={"Aucun historique"}></AppResult>
                  </div>
                )}
              </div>

              <div className={s.resumeBox}>
                <div className={s.resume}>
                  <span>Total brute : <span style={{ fontWeight: "bold" }}>{Number(totalIncome.toFixed(2))} €</span></span>
                  <span>Commission plateforme : <span style={{ fontWeight: "bold" }}> -{platformCommission}%</span></span>
                  {havingPenalty && penalty > 0 && <span style={{ color: "#F70000" }}>Malus annulation : <span style={{ fontWeight: "bold" }}> -{penalty}€</span></span>}
                  <span style={{ marginTop: "10px" }}>Revenu net : <span style={{ fontWeight: "bold" }}> {Number(income.toFixed(2))} €</span></span>
                </div>
              </div>

            </div>}

            {currentPage === 2 && bookedReservations?.length > 0 && <div className={s.pageOneBox}>
              {!isMobile && <div className={s.courseInfoTitle}>
                <span>Revenu<br />brute</span>
                <span>Commission<br />Plateforme</span>
                <span>Revenu<br />net</span>
              </div>}

              <div className={s.coursesBox}>
                {isLoading ? <>
                  <Skeleton></Skeleton>
                  <Skeleton></Skeleton>
                  <Skeleton></Skeleton>
                </> : bookedReservations?.length > 0 ? (
                  bookedCourses && Object.keys(bookedCourses)?.map((date) => {
                    return (
                      <>
                        <div key={date} style={{ marginTop: "10px" }}>
                          <div className={st.dateBox}>
                            {new Intl.DateTimeFormat("fr-FR", {
                              weekday: "long",
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }).format(new Date(date))}
                            {isToday(date) && <div className={st.todayBox}>Aujourd’hui</div>}
                            <div className={st.horizontalLine}></div>
                          </div>
                          {!isMobile && bookedCourses[date].map((course: any) => (
                            <div key={course.id}>
                              <CoursesRoom course={course} currentPage={currentPage} />
                            </div>
                          ))}

                          {isMobile && <div className={st.cardDisplay}>
                            {bookedCourses[date].map((course: any) => (
                              <div key={course.id}>
                                <CoursesRoom course={course} currentPage={currentPage} />
                              </div>
                            ))}
                          </div>}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <div className={s.emptyClass}>
                    <AppResult status={"info"} title={"Aucun historique"}></AppResult>
                  </div>
                )}
              </div>
            </div>}

            {currentPage === 3 && <div className={s.pageOneBox}>
              {!isMobile && withdraws.map((withdraw: any) => (
                <div key={withdraw._id} className={s.withdrawBox}>
                  <div>Retrait du {formatDate(withdraw.createdAt)}</div>
                  <div className={s.withdrawDetailsBox}>
                    <div className={s.withdrawAmountBox}>Total du retrait : {withdraw.price} €</div>
                    <div className={withdraw.status === "DONE" ? s.withdrawDoneStatusBox : s.withdrawPendingStatusBox} style={{ color: withdraw.status === "DONE" ? "#7FB1B2" : "#886100" }}>{withdraw.status === "DONE" ? "Payé" : "En cours de traitement"}</div>
                    {/* <div className={s.withdrawButton}>Détails du retrait</div> */}
                  </div>
                </div>
              ))}

              {isMobile && <div className={st.cardDisplay}>
                {withdraws.map((withdraw: any) => (
                  <div key={withdraw._id} className={s.withdrawBox}>
                    <div>Retrait du {formatDate(withdraw.createdAt)}</div>
                    <div className={s.withdrawDetailsBox}>
                      <div className={s.withdrawAmountBox}>Total du retrait : {withdraw.price} €</div>
                      <div className={withdraw.status === "DONE" ? s.withdrawDoneStatusBox : s.withdrawPendingStatusBox} style={{ color: withdraw.status === "DONE" ? "#7FB1B2" : "#886100" }}>{withdraw.status === "DONE" ? "Payé" : "En cours de traitement"}</div>
                      {/* <div className={s.withdrawButton}>Détails du retrait</div> */}
                    </div>
                  </div>
                ))}
              </div>}
            </div>}

            {currentPage === 4 && <div className={s.pageOneBox}>
              {checkingPaymentInfo && <div>
                <div className={s.paymentModeTitle}>
                  Sélectionne ton mode de paiement préféré
                </div>
                <div className={s.paymentType}>
                  {type.map((type: any) => (
                    <div key={type.name} className={s.paymentTypeBox} onClick={() => { setAddPaymentInfo(true); setCheckingPaymentInfo(false); setSelectedPaymentType(type); }}>
                      <div className={s.paymentTypeBoxImage}>
                        <img src={type.icon} height={65}></img>
                      </div>
                      {type.name}
                    </div>
                  ))}
                </div>
              </div>}

              {addPaymentInfo && <div style={{ width: "100%" }}>
                <div className={s.paymentAddTitle} onClick={() => { setAddPaymentInfo(false); setCheckingPaymentInfo(true); }}>
                  <span>
                    <img src={ArrowBack} height={20} style={{ marginRight: "5px" }}></img>
                    Modifier mon mode de paiement préféré
                  </span>
                </div>

                <div className={s.selectedPaymentBar}>
                  <div className={s.checkBoxIcon}>
                    <img src={CheckIcon} height={18}></img>
                  </div>
                  Paiement par {selectedPaymentType.name}
                </div>

                <div className={s.paymentDescriptionBox}>{selectedPaymentType.description}</div>

                {selectedPaymentType.name === "Virement bancaire" && <div className={s.bankInputBox}>
                  <div onClick={handleClick} className={s.bankInput}>
                    <span>Attestation du RIB en PDF</span>
                    <div className={s.bankInputButton}>
                      <UploadOutlined />
                    </div>
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept="application/pdf"
                    style={{ visibility: "hidden", width: "5px", height: "1px" }}
                    multiple={false}
                    onChange={handleChange}
                  />
                  <AppButton className={isMobile ? s.newInfoButton : s.saveBankInfoButton} loading={isLoading} onClick={updateBankInfos}>Enregistrer mes infos bancaires</AppButton>
                </div>}

                {selectedPaymentType.name === "Virement bancaire" && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", height: "auto", width: "100%" }}>
                  {displayPreview && <div className={s.previewImage}>
                    <iframe
                      src={bankDocUrl}
                      width="100%"
                      height={"100%"}
                      title={"RIB Bancaire"}
                      style={{ border: "none" }}
                    />
                  </div>}

                  {auth?.user?.rib && auth?.user?.rib.includes("https://") && <div className={s.previewImage}>
                    <iframe
                      src={auth?.user?.rib}
                      width="100%"
                      height={"100%"}
                      title={"RIB Bancaire"}
                      style={{ border: "none" }}
                    />
                  </div>}
                </div>}

                {selectedPaymentType.name === "Compte Paypal" && <div className={s.bankInputBox}>
                  <div className={s.bankInput}>
                    <Input
                      type="text"
                      onChange={(e) => setPaypalEmail(e.target.value)}
                      bordered={false}
                      placeholder={selectedPaymentType.uploadText}
                    />
                    <div className={s.bankInputButton}>
                      <MailOutlined />
                    </div>
                  </div>
                  <AppButton className={isMobile ? s.newInfoButton : s.saveBankInfoButton} loading={isLoading} onClick={updatePaypalInfos}>Enregistrer mes infos paypal</AppButton>
                </div>}

                {selectedPaymentType.name === "Compte Paypal" && auth?.user?.paypal && <div className={s.paypalDetails}>
                  Compte PayPal : {auth?.user?.paypal}
                </div>}
              </div>}

            </div>}

            {currentPage === 5 && <div className={s.pageOneBox}>
              {loadingOrganismRooms ? <>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
              </> : <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", height: "auto", width: "100%", alignItems: "center", justifyContent: "space-between", marginBottom: isMobile ? "10px" : "0px" }}>
                <div className={s.selectContainer} ref={containerRef}>
                  <label className={s.selectLabel}>Sélectionner une classe</label>
                  <div className={s.selectBox} onClick={() => setIsOpen(!isOpen)}>
                    <span className={s.selectValue}>{selectedClassroom?.title}</span>
                    <button className={s.selectArrow} type="button">
                      <img src={ArrowDown} height={15} />
                    </button>
                  </div>

                  {isOpen && (
                    <div className={s.selectDropdown}>
                      {organismRooms?.data.map((classroom: any) => (
                        <div
                          key={classroom?._id}
                          className={s.selectOption}
                          onClick={() => handleSelect(classroom)}
                        >
                          {classroom?.title || classroom?.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className={s.pageButtonBox}>
                  {havingPenaltyCollectif && penaltyCollectif > 0 && <div onClick={openPenaltiesDrawer} className={s.dashedBox} style={{ background: "#F7E4E4", color: "#F56666" }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                      Oups ! Tu as une pénalité d’annulation de {" "}
                      <span style={{ color: "#F56666", fontWeight: "bold" }}> -{penalty} €</span>
                    </div>
                    <span style={{ color: "#F56666", fontWeight: "bold", marginLeft: "5px", textDecoration: "underline", cursor: "pointer" }}>En savoir plus</span>
                  </div>}
                </div>

                <div style={{ color: "#7f7c15", fontWeight: 500 }}>Tu peux retirer ce solde<br />dès que les crédits sont consommés</div>

                <div className={s.withdrawButtonBox}>
                  <div className={s.dashedBoxCollectif} style={{ background: walletSummary?.totalCreditsConsumed < walletSummary?.requiredCredits ? "#fdf4e4" : "#E5FFF2", color: walletSummary?.totalCreditsConsumed < walletSummary?.requiredCredits ? "#7f7c15" : "#4BB980", fontWeight: "bold" }}>
                    Pack de crédits restants : {Number(walletSummary?.totalCreditsConsumed.toFixed(2))}/{Number(walletSummary?.requiredCredits.toFixed(2))}
                  </div>
                  {walletSummary?.totalCreditsConsumed >= walletSummary?.requiredCredits ? walletSummary?.canWithdrawal ? (
                    <Button className={s.newButton} onClick={() => handleCollectifWithdraw(walletSummary?.grossIncome)}>Demander un retrait</Button>
                  ) : (
                    <Button className={isMobile ? s.demandeRetraitButtonMobile : s.demandeRetraitButton}>
                      Paiement en cours de traitement...
                    </Button>
                  ) : <></>}
                </div>
              </div>}

              {!isMobile && successCollectifSessions?.length > 0 && <div className={s.courseInfoTitleCollectif}>
                <span>Revenu net</span>
                <span>Crédit utilisé</span>
              </div>}

              <div className={s.coursesBox}>
                {isLoading ? <>
                  <Skeleton></Skeleton>
                  <Skeleton></Skeleton>
                  <Skeleton></Skeleton>
                </> : successCollectifSessions?.length > 0 ? (
                  successCollectifCourses && Object.keys(successCollectifCourses)?.map((date) => {
                    return (
                      <>
                        <div key={date} style={{ marginTop: "10px" }}>
                          <div className={st.dateBox}>
                            {new Intl.DateTimeFormat("fr-FR", {
                              weekday: "long",
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }).format(new Date(date))}
                            {isToday(date) && <div className={st.todayBox}>Aujourd’hui</div>}
                            <div className={st.horizontalLine}></div>
                          </div>
                          {!isMobile && successCollectifCourses[date].map((course: any) => (
                            <div key={course.id}>
                              <CoursesRoom course={course} currentPage={currentPage} />
                            </div>
                          ))}

                          {isMobile && <div className={st.cardDisplay}>
                            {successCollectifCourses[date].map((course: any) => (
                              <div key={course.id}>
                                <CoursesRoom course={course} currentPage={currentPage} />
                              </div>
                            ))}
                          </div>}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <div className={s.emptyClass}>
                    <AppResult status={"info"} title={"Aucun historique"}></AppResult>
                  </div>
                )}
              </div>

              <div className={s.resumeBoxCollectif}>
                <div className={s.resumeCollectif}>
                  <span>Revenu net à ce jour : <span style={{ fontWeight: "bold" }}> {Number(walletSummary?.grossIncome.toFixed(2))} €</span></span>
                </div>
              </div>

            </div>}

          </div>
        </div>
      </div>

      <Drawer
        className="drawer"
        placement="right"
        width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "75%" : isMediumScreen ? "70%" : isNormalScreen ? "65%" : "60%"}
        onClose={() => setPenaltiesDrawerOpen(false)}
        visible={penaltiesDrawerOpen}
        closable={true}
        title={
          <div style={{ fontSize: isMobile ? "12px" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>Pénalité d'annulation <span style={{ marginLeft: "10px" }}><HelpPopover id={"portefeuille_home"}></HelpPopover></span></div>
          </div>
        }
        headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
        closeIcon={
          <img
            src={ArrowBack}
            height={isMobile ? 12 : 18}
            style={{}}
          ></img>
        }
        drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "30px", borderBottomLeftRadius: isMobile ? "0px" : "30px", boxShadow: "-3px 3px 34px #39393929" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            padding: isMobile ? "0 20px" : "0 50px",
            width: "100%",
          }}
        >
          <div className={s.drawer}>
            <div className={s.drawerTitle}>Annulation à moins de 24h</div>
            <div className={s.penaltiesBox}>
              {isLoading ? <>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
              </> : penalties?.length > 0 ? (
                <>
                  {!isMobile && penalties.map((course: any) => (
                    <div key={course.id}>
                      <CoursesRoom course={course?.reserveId} currentPage={5} penalty={course?.penaltyAmount} />
                    </div>
                  ))}

                  {isMobile && <div className={st.cardDisplay}>
                    {penalties.map((course: any) => (
                      <div key={course.id}>
                        <CoursesRoom course={course?.reserveId} currentPage={5} penalty={course?.penaltyAmount} />
                      </div>
                    ))}
                  </div>}
                </>
              ) : (
                <div className={s.emptyClass}>
                  <AppResult status={"info"} title={"Aucune pénalité"}></AppResult>
                </div>
              )}
            </div>
          </div>
        </div>
      </Drawer>

      <Drawer
        className="drawer"
        placement="right"
        width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "55%" : isMediumScreen ? "50%" : isNormalScreen ? "45%" : "40%"}
        onClose={() => setWithdrawDrawerOpen(false)}
        visible={withdrawDrawerOpen}
        closable={true}
        title={
          <div style={{ fontSize: isMobile ? "12px" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>Demander un retrait<span style={{ marginLeft: "10px" }}><HelpPopover id={"portefeuille_home"}></HelpPopover></span></div>
          </div>
        }
        headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
        closeIcon={
          <img
            src={ArrowBack}
            height={isMobile ? 12 : 18}
            style={{}}
          ></img>
        }
        drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "30px", borderBottomLeftRadius: isMobile ? "0px" : "30px", boxShadow: "-3px 3px 34px #39393929" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            padding: isMobile ? "0 20px" : "0 50px",
            width: "100%",
          }}
        >
          <div className={s.drawer}>
            {auth?.user?.rib && auth?.user?.paypal && <div className={`${s.drawerTitle} paymentSwitch`}>
              Sélectionne ton mode de paiement
              <Switch
                checked={bankPayment}
                checkedChildren="Virement bancaire"
                unCheckedChildren="Compte PayPal"
                onChange={(e) => {
                  setBankPayment(!bankPayment);
                }}
                style={{ marginLeft: "10px" }}
              />
            </div>}

            <div className={s.paymentDraweBox}>
              {bankPayment ? <div className={s.paymentInfo}>
                <img src={auth?.user?.rib !== "" ? Check : Close} height={30} style={{ marginRight: "10px" }}></img>
                <span style={{ fontWeight: "bold", marginRight: "5px" }}>Information de paiement </span> (RIB)
                <div style={{ marginLeft: "10px", height: "15" }}><a href={auth?.user?.rib ? auth?.user?.rib : "#"} target="_blank"><FilePdfOutlined /></a></div>
              </div> : <div className={s.paymentInfo}>
                <img src={auth?.user?.paypal !== "" ? Check : Close} height={30} style={{ marginRight: "10px" }}></img>
                <span style={{ fontWeight: "bold", marginRight: "5px" }}>Information de paiement </span> (PayPal)
                {auth?.user?.paypal}
              </div>}

              {!isCollectifWithdrawal && <div className={s.paymentInfo}>
                <img src={Check} height={30} style={{ marginRight: "10px" }}></img>
                <span style={{ fontWeight: "bold", marginRight: "5px" }}>Eligibilité de retrait </span> (50 € minimum)
              </div>}

              <div className={s.dashedBox} style={{ background: "#E5FFF2", color: "#4BB980", fontWeight: "bold", marginTop: "20px" }}>
                Solde net retirable : {isCollectifWithdrawal ? Number(collectifAmount.toFixed(2)) : Number(income.toFixed(2))} €
              </div>

              <Button className={s.newButton} loading={loadingRetrait} style={{ marginTop: "50px" }} onClick={isCollectifWithdrawal ? confirmCollectifWithdrawRequest : confirmWithdrawRequest}>Confirmer ma demande</Button>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};
